import { render, staticRenderFns } from "./livingverify.vue?vue&type=template&id=32c8c277&scoped=true&"
import script from "./livingverify.vue?vue&type=script&lang=js&"
export * from "./livingverify.vue?vue&type=script&lang=js&"
import style0 from "./livingverify.vue?vue&type=style&index=0&id=32c8c277&less=true&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c8c277",
  null
  
)

export default component.exports